<template>
	<div class="primary-main bank-main school-manage" v-loading="loading">
		<div class="search">
			<el-input v-model="dlsmc" placeholder="代理商、代理商编码、负责人、手机号" clearable style="width: 290px;margin-bottom: 10px;"></el-input>
			<el-button @click="findDlsglList" style="margin-bottom: 10px;" icon="el-icon-search">查询</el-button>
		</div>
    <el-row style="height: 330px;overflow-y: auto">
      <el-col :span="8" style="margin-bottom: 10px" v-for="(item, index) in dlsglList" :key="item.id" @click.native="selectDlsgl(item)">
        <el-card :body-style="{ padding: '0px' }" :class="item.isSelect?'box-card card-select':'box-card'">
          <div slot="header" class="clearfix" style="position: relative;height: 15px">
            <span style="color: #18CE58;position: absolute;left: 2px" v-if="item.isSelect" class="el-icon-success"></span>
            <span style="position: absolute;left: 25px;top: -3px;">{{ item.dlsmc }}</span>
          </div>
          <div class="item-content">
            <div class="text item"><label>代理商编码：</label>{{item.dlsbm}}</div>
            <div class="text item"><label>所属城市：</label>{{item.csmc}}</div>
            <div class="text item"><label>负责人：</label>{{item.fzr}}</div>
            <div class="text item"><label>手机号：</label>{{item.sjh}}</div>
            <div class="text item">
              <label>账户余额积分：</label>
              <span v-if="item.ywList && item.ywList.length">
                <span v-for="(yw, i) in item.ywList" :key="i">
                  {{ yw.ywmc }}：{{ yw.zhyejf }}<i v-if="i!=item.ywList.length-1">，</i>
                </span>
              </span>
            </div>
            <img v-if="item.zhzt==1" src="../../assets/img/02yiqiyong.png" height="45" width="63" style="position: absolute;right: 25px;bottom: 30px;"/>
<!--            <div class="text item">
              <label>账户状态：</label>
              <span v-if="item.zhzt==0">已禁用</span>
              <span v-if="item.zhzt==1">启用中</span>
            </div>-->
          </div>
        </el-card>
      </el-col>
      <div style="text-align:center;margin: auto;" v-if="dlsglList.length == 0">
        <el-empty description="暂无代理商,请查询......"></el-empty>
      </div>
    </el-row>
    <el-row style="margin-top: 10px;border-top: #CCCCCC 1px solid;">
      <el-form ref="form" label-width="100px" label-position="right" style="margin-top: 10px;padding-left: 35%">
        <el-form-item label="业务：">
          <el-select v-model="ywcode" placeholder="请选择业务" clearable style="width: 200px;margin-bottom: 10px;">
            <el-option v-for="item in ywList" :key="item.ywcode" :label="item.ywmc" :value="item.ywcode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值数额：">
          <el-input v-model="czse" @input="value => numberInputHandler(value, 'czse', this)" min="0" @change="getCzjf" type="Number" placeholder="请输入充值数额" clearable style="width: 200px;margin-bottom: 10px;"></el-input>
          <span>（元）</span>
        </el-form-item>
        <el-form-item label="充值积分：">
          <el-input v-model="czjf" disabled type="Number" placeholder="充值积分" clearable style="width: 200px;margin-bottom: 10px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="dlsglCzjlSave">确认充值</el-button>
        </el-form-item>
      </el-form>
    </el-row>
	</div>
</template>

<script>
export default {
	name: 'dlsCz',
	data() {
		return {
			userType: sessionStorage.getItem("userType"),
      dlsmc: '',//代理商名称
      curDate: new Date().getTime(),
      dlsglList: [],
			loading: false,
      dlsglId: '',
      czse: 0,
      czjf: 0,
      isSelect: false,
      selectDls: {},
      ywList: [], // 业务列表
      ywcode: '' // 选中的业务code
		}
	},
  components:{},
	created() {
	},
	methods: {
    // 获取数据
    findDlsglList() {
      var _this = this;
      var params = {
        dlsmc: _this.dlsmc,
        zhzt: 1
      }
      _this.loading = true;
      _this.$post("dlsgl/DlsglController/dlsglList", params).then(rep => {
        _this.loading = false;
        if (rep.code == 1) {
          // 使用map创建新对象确保响应式
          _this.dlsglList = rep.result.dlsglList.map(item => ({
            ...item,
            isSelect: false
          }));
          _this.selectDlsgl(_this.selectDls);
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
    // 选择代理商管理（实现严格单选）
    selectDlsgl(item){
      this.selectDls = item;
      // 先记录当前选中状态
      const wasSelected = item.isSelect;

      // 创建新数组确保响应式更新
      const newList = this.dlsglList.map(item2 => {
        return {
          ...item2,
          isSelect: item2.id === item.id ? !wasSelected : false
        };
      });
      this.dlsglList = newList;

      // 同步更新选中ID（如果取消选中则清空）
      this.dlsglId = wasSelected ? '' : item.id;

      // 更新业务列表为选中代理商的ywList
      if (!wasSelected && item.ywList) {
        this.ywList = item.ywList;
      } else {
        this.ywList = [];
      }
      this.ywcode = ''; // 重置选中的业务
    },
    // 计算充值积分
    getCzjf(){
      //获取代理商充值比例
      this.$post('sys/findSysConfigByConfigKey',{configKey: "dls_czbl"}).then((arg) => {
        var dlsCzbl = arg.result.sysConfig.configValue;
        if(dlsCzbl){
          this.czjf = (this.czse * dlsCzbl).toFixed(0);
        }else{
          this.$message({
            type: "error",
            message: '请先设置代理商充值比例'
          });
        }
      })
    },
    dlsglCzjlSave(){
      var _this = this;
      if(!_this.dlsglId){
        _this.$message({
          type: "error",
          message: '请选择代理商'
        });
        return;
      }
      if(!_this.ywcode){
        _this.$message({
          type: "error",
          message: '请选择业务'
        });
        return;
      }
      if(!_this.czse){
        _this.$message({
          type: "error",
          message: '请输入充值数额'
        });
        return;
      }else{
        if(_this.czse<=0){
          _this.$message({
            type: "error",
            message: '充值数额不能小于等于0'
          });
          return;
        }
      }
      _this.$confirm('是否确认充值', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var params = {
          dlsglId: _this.dlsglId,
          czse: _this.czse,
          czjf: _this.czjf,
          ywcode: _this.ywcode
        }
        this.$post("dlsgl/DlsglController/dlsglCzjlSave", params,'json').then(rep => {
          if (rep.code == '1') {
            this.$message({
              type: "success",
              message: '充值成功'
            });
            this.findDlsglList();
            //this.dlsglId='';
            this.czse='';
            this.czjf='';
            this.ywcode='';
            this.ywList=[]; // 清空业务列表
          } else {
            this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      })
    }
	},
}
</script>

<style lang="less">
.school-manage {
	.search {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 10px;
		.el-select,
		.el-input {
			margin-right: 10px;
		}
	}
  .item-content{
    position: relative;
    padding: 10px 20px 10px;
  }
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 8px;
    label{
      width: 100px;
      display: inline-block;
      text-align: right;
      color: #333333;
      font-weight: 400;
    }
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    cursor: pointer;
    width: 98%;
    height: 185px;
    .el-card__header{
      padding: 10px 10px;
      background: #ECECEC;
    }
  }
  .card-select{
    border: 1px solid #18CE58;
  }
}
</style>
